import { callApi } from "./index"

export const getCategories = (): Promise<Category[]> => {
  return callApi("/api/EasyDirectoryAPI/get-categories", { })
}

export interface Category {
  Id: number
  Name: string
  Slug: string
}
